import axios from 'axios';
import {getStore, setStore} from './storage';
import {router} from '../router/index';
import {Message} from 'view-design';
import qs from 'qs';


// export const serverAddress = "http://192.168.0.219:66";
export const serverAddress = "https://process.yonglijc.com.cn";
export const makeupAddress = "http://192.168.0.219:62";// 拼版ip
// export const processAddress = "http://192.168.0.104:63";//进度管控ip
// export const ebookAddress = "https://test.wprint.com.cn/ebooks/index.html"  // 电子书
// export const fontAddress = "http://192.168.0.104:60"; //代客下单
// 统一请求路径前缀
export let base = `${serverAddress}/xd/api`;



// 超时设定
axios.defaults.timeout = 60000;
/*axios.interceptors.request.use(async (config) => {
//只针对get方式进行序列化
  if (config.method === 'get') {
    config.paramsSerializer = function(params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  }
}*/
axios.interceptors.request.use(config => {
  if (config.method === 'get') {
    config.paramsSerializer = function(params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  }
  return config;
}, err => {
  Message.error('请求超时');
  return Promise.resolve(err);
});
// http response 拦截器
axios.interceptors.response.use(response => {

  const data = response.data;
  console.log(data)
  // 根据返回的code值来做不同的处理(和后端约定)
  switch (data.code) {
    case 401:
      // 未登录 清除已登录状态
      window.localStorage.clear();
      window.sessionStorage.clear();
      router.push('/login');
      break;
    case 403:
      // 没有权限
      if (data.message) {
        Message.error(data.message);
      } else {
        Message.error("未知错误");
      }
      break;
    case 500:

      // 错误
      if (data.message) {
        if(data.message.indexOf('Duplicate entry') >= 0 && data.message.indexOf('username_type') >= 0){
          Message.error('用户名不能重复!');
        } else if(data.message.indexOf('目的地已配置') >= 0){
          Message.error('目的地:'+data.data+'已配置过，不能重复配置！');
        } else if(data.message.indexOf("暂无导出数据")>=0){
          Message.error('暂无导出数据！');

        } else {
          Message.error(data.message);
        }

      } else {
        Message.error("未知错误");
      }
      break;
    case 3000:
      Message.error({
        content: data.message,
        duration: 3
      });
    default:
      return data;
  }

  return data;
}, (err) => {
  let message = '';
  if(err.response.status == 401 ){
    console.log('ahhah')
    // 未登录 清除已登录状态
    window.localStorage.clear();
    window.sessionStorage.clear();
    router.push('/login');
  }
  console.log(err.response)
  console.log(err.response.data.message)
  if(err && err.response &&err.response.data && err.response.data.message){
    message = err.response.data.message
  } else {
    message = '服务器异常！';
  }
  // 返回状态码不为200时候的错误处理
  Message.error({
        content: message,
        duration: 3
      });
  return Promise.resolve(err);
});
//封装get请求
export const getRequestByBlob = (url, params) => {
  let accessToken = getStore('accessToken');
  return axios({
    method: 'get',
    url: `${base}${url}`,
    timeout: 300000,
    params: params,
    responseType: 'blob',
    headers: {
      'accessToken': accessToken,
      'Content-Type': 'multipart/x-www-form-urlencoded'
    }
  });
};
//封装get请求
export const getRequest = (url, params) => {
  let accessToken = getStore('accessToken');
  return axios({
    method: 'get',
    url: `${base}${url}`,
    timeout: 300000,
    params: params,
    headers: {
      'accessToken': accessToken
    }
  });
};
//封装get请求
export const getRequest2 = (url, params) => {
  return axios({
    method: 'get',
    url: `${url}`,
    params: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    }
  });
};

//封装get请求
export const getRequestForJson = (url, params) => {
  let accessToken = getStore('accessToken');
  return axios({
    method: 'get',
    url: `${base}${url}`,
    params: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'accessToken': accessToken
    }
  });
};
//封装post请求
export const postRequest = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    timeout: 600000,
    transformRequest: [function (data) {
      let ret = '';
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
      }
      return ret;
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'accessToken': accessToken
    }
  });
};
//封装post请求
export const postRequestForJsonByBlob = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: 'post',
    url: `${base}${url}`,
    responseType: 'blob',
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'accessToken': accessToken
    }
  });
};
//封装post请求
export const postRequestForJson = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'accessToken': accessToken
    }
  });
};
//封装post请求
export const postRequestForJson2 = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: 'post',
    url: `${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'accessToken': accessToken
    }
  });
};

//封装put请求
export const putRequest = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    transformRequest: [function (data) {
      let ret = '';
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
      }
      return ret;
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'accessToken': accessToken
    }
  });
};
//封装put请求
export const putRequestForJson = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    // transformRequest: [function (data) {
    //     let ret = '';
    //     for (let it in data) {
    //         ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
    //     }
    //     return ret;
    // }],
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'accessToken': accessToken
    }
  });
};

//封装delte
export const deleteRequest = (url, params) => {
  let accessToken = getStore('accessToken');
  return axios({
    method: 'delete',
    url: `${base}${url}`,
    params: params,
    headers: {
      'accessToken': accessToken
    }
  });
};
//封装delete请求
export const deleteRequestForJson = (url, params) => {
  let accessToken = getStore("accessToken");
  return axios({
    method: 'delete',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'accessToken': accessToken
    }
  });
};
//上传文件
export const uploadFileRequest = (url, params) => {
  let accessToken = getStore('accessToken');
  return axios({
    method: 'post',
    url: `${base}${url}`,
    params: params,
    headers: {
      'accessToken': accessToken
    }
  });
};



// WEBPACK FOOTER //
// ./src/api/axios.js